import{Box,Stack,Typography}from'@mui/material';
import{rasanaTokens}from'./theme';

export type RasanaLogoVariant='mark'|'horizontal'|'stacked';

export function RasanaMark({
 size=44,
 title='Rasana'
}:{size?:number;title?:string}){
 return <Box
  component="svg"
  role="img"
  aria-label={title}
  viewBox="0 0 100 100"
  sx={{
   display:'block',
   width:size,
   height:size,
   flex:'0 0 auto'
  }}
 >
  <title>{title}</title>

  {/* Connected information / upper R */}
  <path
   d="M11 11H57.5C76.8 11 90 24.6 90 43.1C90 61.3 76.7 73 58.7 73H49.3L32.7 56.4H57.4C67 56.4 73.4 51.4 73.4 43.1C73.4 34.6 67 29.6 57.4 29.6H11V11Z"
   fill={rasanaTokens.primary}
  />

  {/* Judgement / directional leg */}
  <path
   d="M31.1 56.4H54.8L89.4 90H65.9L31.1 56.4Z"
   fill={rasanaTokens.navy}
  />

  {/* Value / outcome */}
  <path
   d="M11 52.3V90H49L11 52.3Z"
   fill={rasanaTokens.gold}
  />
 </Box>;
}

export default function RasanaLogo({
 variant='horizontal',
 markSize,
 inverse=false,
 tagline=true
}:{
 variant?:RasanaLogoVariant;
 markSize?:number;
 inverse?:boolean;
 tagline?:boolean;
}){
 if(variant==='mark'){
  return <RasanaMark size={markSize??44}/>;
 }

 const stacked=variant==='stacked';
 const wordColor=inverse?'#FFFFFF':rasanaTokens.navy;
 const secondary=inverse?'rgba(255,255,255,.68)':rasanaTokens.textSecondary;

 return <Stack
  direction={stacked?'column':'row'}
  alignItems="center"
  spacing={stacked?1.4:1.75}
  sx={{minWidth:0}}
 >
  <RasanaMark size={markSize??(stacked?82:44)}/>

  <Box sx={{minWidth:0,textAlign:stacked?'center':'left'}}>
   <Typography
    component="div"
    sx={{
     color:wordColor,
     fontWeight:600,
     fontSize:stacked?28:20,
     lineHeight:1,
     letterSpacing:stacked?'.22em':'.19em',
     pl:stacked?'.22em':'.19em',
     whiteSpace:'nowrap'
    }}
   >
    RASANA
   </Typography>

   {tagline&&
    <Typography
     component="div"
     sx={{
      color:secondary,
      mt:stacked?1:.65,
      fontSize:stacked?10:8.5,
      lineHeight:1.3,
      fontWeight:500,
      letterSpacing:stacked?'.28em':'.22em',
      pl:stacked?'.28em':'.22em',
      whiteSpace:'nowrap',
      textTransform:'uppercase'
     }}
    >
     A calmer way to work
    </Typography>
   }
  </Box>
 </Stack>;
}
